export default __webpack_public_path__ + "static/img-channel-thumbnail-third-b76c4d80afdd72ffcd9ed47dfe9e9a7d.png";